import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  ID_ESTADO_ENTREGADO,
  ID_ESTADO_NO_CONFIRMADO,
  ID_ESTADO_EN_ESPERA,
  ID_ESTADO_MONTOS_NO_OK,
  ID_ESTADO_MONTOS_OK,
  ID_ESTADO_DEVUELTO,
  ID_ESTADO_CANCELADO
} from '../../../constants/pedidoEstados'
import { toastErrorLog } from '../../../helpers/toastErrorLog'
import { useAuth } from '../../../hooks/useAuth'
import { Reclamar } from '../../pages/reclamar/Reclamar'
import DetallePago from '../../pedidos/DetallePago'
import DetallePie from '../../pedidos/DetallePie'
import Descripcion from '../../publicaciones/Descripcion'
import DetalleCabecera from '../../publicaciones/DetalleCabecera'
import * as impuestoService from '../../servicios/impuestoService'
import * as mensajesService from '../../servicios/mensajesService'
import * as pedidosService from '../../servicios/pedidosService'
import BordeDetalle from '../../ui/BordeDetalle'
import DetalleCobro from '../../ventas/DetalleCobro'
import { DetalleEstadoPedido } from '../../ventas/DetalleEstadoPedido'
import { MensajeriaNew } from '../mensajeria/MensajeriaNew'

const estadosValidos = [
  ID_ESTADO_MONTOS_NO_OK,
  ID_ESTADO_MONTOS_OK,
  ID_ESTADO_EN_ESPERA,
  ID_ESTADO_NO_CONFIRMADO,
  ID_ESTADO_DEVUELTO,
  ID_ESTADO_CANCELADO
]

const PedidoItemDetalle = () => {
  const { loginDataContext: { idUsuario: usuario, empid } = {} } = useAuth()
  const { idPedidoItem } = useParams()
  const location = useLocation()

  const navigate = useNavigate()

  const [mensajes, setMensajes] = useState([])
  const [pedido, setPedido] = useState({})
  const [esVentas, setEsVentas] = useState(false)
  const [estados, setEstados] = useState([])
  const [reclamo, setReclamo] = useState(false)
  const [percepciones, setPercepciones] = useState([])

  const buscarMensajes = async (idComprador) => {
    try {
      const respuesta = await mensajesService.buscarPorPedidoItem(
        idPedidoItem,
        idComprador ?? pedido.idComprador
      )
      const data = respuesta?.data

      setMensajes(
        data?.length
          ? [...data].sort((a, b) => new Date(a.fechaEscrito) - new Date(b.fechaEscrito))
          : []
      )
    } catch {
      setMensajes([])
    }
  }

  const buscarPedido = async () => {
    try {
      const pedidoResp = await pedidosService.buscarPorPedidoItem(idPedidoItem)
      const data = pedidoResp?.data

      if (!data?.pedidoItems?.length) {
        toastErrorLog(null, 'No se encontró el pedido o fue eliminado.', 'pedidos')
        navigate('/Pedidos', { replace: true })
        setPedido({})
        return
      }
      setEsVentas(data.idVendedor === usuario || data.pedidoItems[0].empidVendedor === empid)
      setEstados(data.estados)
      const pedidoAux = {
        ...data.pedidoItems[0],
        fechaPedido: data.fechaPedido,
        idComprador: data.idComprador,
        idPedido: data.idPedido,
        precioEnvio: data.pedidoItems[0]?.precioEnvio ?? data.precioEnvio ?? 0,
        envioTipo: data.pedidoItems[0]?.envioTipo ?? data.envioTipo ?? '',
        idMedioEnvio: data.pedidoItems[0]?.idMedioEnvio ?? data.idMedioEnvio ?? null
      }
      setPedido(pedidoAux)
      buscarMensajes(data.idComprador)
    } catch {
      setPedido({})
    }
  }

  const actualizarPedido = async () => {
    await buscarPedido()
  }

  const deshabilitarCambio = estadosValidos.includes(pedido.idPedidoItemEstado)

  useEffect(() => {
    buscarPedido()
  }, [idPedidoItem])

  useEffect(() => {
    obtenerPercepciones(pedido.idPedido)
  }, [pedido.idPedido])

  const obtenerPercepciones = async (idPedido) => {
    if (!idPedido) {
      setPercepciones([])
      return
    }
    const { data } = await impuestoService.buscarTodos(idPedido)
    setPercepciones(Array.isArray(data) ? data : [])
  }

  const navegar = () => {
    const navegarA = location.state?.origen || (esVentas ? '/Ventas' : '/Pedidos')
    navigate(navegarA)
  }

  return (
    Object.keys(pedido).length > 0 && (
      <BordeDetalle titulo={'Detalle del pedido'} onCerrarClick={() => navegar()}>
        <DetalleCabecera detalle={pedido} esVentas={esVentas} permiteComprar={false} />

        <Descripcion descripcion={pedido.descripcion} />

        <DetallePago fechaPedido={pedido.fechaPedido} pedidoItem={pedido} esVentas={esVentas} />
        {esVentas && (
          <>
            <DetalleEstadoPedido
              pedido={pedido}
              estados={estados}
              onActualizar={actualizarPedido}
              disabled={deshabilitarCambio}
            />
            <hr></hr>
            <DetalleCobro
              cantidad={pedido?.cantidad}
              precio={pedido?.precioUnitario}
              porcentajeExposicion={pedido?.porcentajeExposicion}
              exposicion={pedido?.exposicion}
              monedaSimbolo={pedido?.monedaSimbolo}
              alicuota={pedido?.alicuota}
              precioEnvio={pedido?.precioEnvio}
              esTiendaOficial={pedido?.esTiendaOficial}
              porcComision={pedido?.porcComision}
              porcComisionTienda={pedido?.porcComisionTienda}
              montoComision={pedido?.montoComision}
              tipoCobro={pedido?.tipoCobro}
              descuentoExposicion={pedido?.descuentoExposicion}
              descuentoTiendaOficial={pedido?.descuentoTiendaOficial}
              totalCobro={pedido?.totalCobro}
              percepciones={percepciones}
            />
            <hr />
          </>
        )}
        <Reclamar
          reclamo={reclamo}
          setReclamo={setReclamo}
          idComprador={pedido.idComprador}
          idVendedor={pedido.idVendedor}
          tipoDoc={'pedido'}
          id={idPedidoItem}
          actualizarMensajes={buscarMensajes}
          pedido={pedido}
        />
        <MensajeriaNew
          titulo={'Mensajería interna'}
          id={idPedidoItem}
          tipoDoc={'pedido'}
          idVendedor={pedido.idVendedor}
          idComprador={pedido.idComprador || usuario}
          mensajes={mensajes}
          tipoMensajes={'chat'}
          usuario={usuario}
          actualizarMensajes={buscarMensajes}
          pedidoEntregado={pedido.idPedidoItemEstado === ID_ESTADO_ENTREGADO}
          empid={empid}
        />
        <DetallePie
          idPublicacion={pedido.idPublicacion}
          idEstadoPedidoItem={pedido.idPedidoItemEstado}
          setReclamo={setReclamo}
          esVentas={esVentas}
        />
      </BordeDetalle>
    )
  )
}

export default PedidoItemDetalle
